module.exports = __webpack_public_path__ + "img/maldives.edcfa1a3.jpg";